import { render, staticRenderFns } from "./modalMOTM.vue?vue&type=template&id=2b4c143b&"
import script from "./modalMOTM.vue?vue&type=script&lang=js&"
export * from "./modalMOTM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports